var render, staticRenderFns
import script from "./ActivityItemContent.vue?vue&type=script&lang=tsx&"
export * from "./ActivityItemContent.vue?vue&type=script&lang=tsx&"
import style0 from "./ActivityItemContent.vue?vue&type=style&index=0&id=f056e03e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports